import { Divider } from '@material-ui/core'
import React from 'react'
import { FiChevronRight } from 'react-icons/fi'
import styled from '../../../theme'
import Flex from 'typescript-styled-flex'
import { useDispatch } from 'react-redux'
import { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'
import reloadApplication from '../../../actions/synchronize/reloadApplication'
import ExternalLink from './ExternalLink'
import getEnv from '../../../utils/getEnv'

const Wrapper = styled(Flex as any)<IWithSize>`
  cursor: pointer;
  padding: ${({ size }) => (size ? 1.25 * size : 1.25)}em;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  font-weight: 500;

  &:hover {
    background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
  }
`

function AppVersion({ isSidebarOpen, size = 1 }: IAppVersion) {
  const dispatch = useDispatch()

  function reload() {
    const env = getEnv()
    if (env === 'dev') {
      // eslint-disable-next-line
      const a = null
      // @ts-ignore
      a.b()
    } else {
      dispatch(reloadApplication())
    }
  }

  return (
    <React.Fragment>
      {isSidebarOpen && (
        <ExternalLink
          size={size}
          onClick={reload}
          // href={
          //   'https://support.bed-booking.com/hc/en-us/articles/360010162739-Web-App-2-1'
          // }
        >
          <Divider />
          <Wrapper size={size}>
            <Flex full={true}>Version {process.env.REACT_APP_VERSION}</Flex>

            <b>
              <FiChevronRight size={16 * size} />
            </b>
          </Wrapper>
        </ExternalLink>
      )}
    </React.Fragment>
  )
}

export default AppVersion

export interface IAppVersion {
  version: string
  isSidebarOpen: boolean
  size?: number
}
